import { render, staticRenderFns } from "./UploadItemImage.vue?vue&type=template&id=27878078&scoped=true&"
import script from "./UploadItemImage.vue?vue&type=script&lang=js&"
export * from "./UploadItemImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadItemImage.vue?vue&type=style&index=0&id=27878078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27878078",
  null
  
)

export default component.exports